<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat >
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Tax Rates</v-toolbar-title>
    <v-spacer/>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>

  <v-data-table
    disable-pagination
    hide-default-footer
    :height="520"
    :headers="headers"
    :fixed-header="true"
    :items="confirmedTaxRates ? allTaxRates: allTaxRates.filter(a => a.CheckerID === 0)"
    :search="search"
    sort-by="MakeDate"
    sort-desc
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top >

        <!-- rejection dialog  -->
          <v-dialog persistent v-model="rejectionDialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
              </v-card-title>

              <v-card-text>
                <v-select
                  filled dense
                  v-model="RejectionStatus"
                  :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="RejectionReasonDescription"
                  item-value="RejectionReasonID"
                  label="Rejection Reasons"
                ></v-select>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <div class="text-right mb-4">
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="RejectionStatus = 0; rejectionDialog = false">cancel</v-btn>
                  <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus()">ok</v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>

<!-- the delete dialog  -->
          <v-dialog persistent v-model="deleteDialog" max-width="350px">
            <v-card>
              <v-card-title>
                <span class="subtitle-1 grey--text text-center ma-4 mx-7">Are you sure you want to DELETE  the selected item?</span>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <div class="text-right mb-4">
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteDialog = false">no</v-btn>
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteItem()">yes</v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>

      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="create">
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Create New Tax Rate</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-row class="ml-1 mr-1">
        <v-col>
          <v-select
            filled dense
            v-model="tax_rate.TaxID"
            :items="allTaxes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            item-text="TaxCode"
            item-value="TaxID"
            label="Tax"
          ></v-select>
          <v-checkbox
            v-model="tax_rate.IsAbsolute"
            class="mt-0"
            label="Absolute Value?"
          ></v-checkbox>
        </v-col>
        <v-col>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="tax_rate.EffectiveDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="tax_rate.EffectiveDate"
              label="Effective Date"
              append-icon="mdi-calendar-month"
              readonly
              dense filled color="#2A353D"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
            </template>
            <v-date-picker color="#2A353D" v-model="tax_rate.EffectiveDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu.save(tax_rate.EffectiveDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="tax_rate.Rate"
            label="Rate"
            required type="number"
            :rules="TextFieldRules"
          ></v-text-field>
          <div class="text-right mt-7">
            <v-btn class="white--text mr-3" small color="#2A353D" @click="closeCreate()">close</v-btn>
            <v-btn class="white--text mr-3" small color="#2A353D" :disabled="!valid" @click="createNew()">submit</v-btn>          
          </div>   
        </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>

      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="edit" >
        <v-toolbar dense flat color="#DBEFFA">
            <v-spacer/>
            <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentTaxRate.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
            <span v-if="currentTaxRate.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentTaxRate.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
            <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentTaxRate.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
        


       </v-toolbar>
        <v-row class="ml-1 mr-1">
        <v-col>
          <v-select
            filled dense
            v-model="currentTaxRate.TaxID"
            :items="allTaxes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            item-text="TaxCode"
             :readonly="view"
            item-value="TaxID"
            label="Tax"
          ></v-select>
          <v-checkbox
            v-model="currentTaxRate.IsAbsolute"
            class="mt-0"
            :readonly="view"
            label="Absolute Value?"
          ></v-checkbox>
        </v-col>
        <v-col>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="currentTaxRate.EffectiveDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="currentTaxRate.EffectiveDate"
              label="Effective Date"
              append-icon="mdi-calendar-month"
              readonly
              :disabled="view"
              dense filled color="#2A353D"
             v-bind="attrs"
              v-on="on"
            ></v-text-field>
            </template>
            <v-date-picker color="#2A353D" v-model="currentTaxRate.EffectiveDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu.save(currentTaxRate.EffectiveDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="currentTaxRate.Rate"
            label="Rate"
            :readonly="view"
            required type="number"
            :rules="TextFieldRules"
          ></v-text-field>
          <div class="text-right mt-7">
            <v-btn class="white--text mr-3" small color="#2A353D" @click="view=false;closeEdit()">close</v-btn>
            <v-btn class="white--text mr-3" v-if="!view" small color="#2A353D" @click="update()">save</v-btn>          
          </div>   
        </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>
      <v-container row>

        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-if="showCreateBtn == true" v-show="confirmedTaxRates" @click="showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-show="confirmedTaxRates" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "xls"
                name    = "Tax Rates.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "csv"
                name    = "Tax Rates.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" v-show="confirmedTaxRates" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <v-btn v-show="!confirmedTaxRates" @click="confirmedTaxRates = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>
    </template>

  <template v-slot:item.status="{ item }">
      <v-chip outlined small color="error" v-if="item.RejectionID !== 0">rejected</v-chip>
      <v-chip outlined small color="warning" v-if="item.CheckerID == 0">pending</v-chip>
      <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0">confirmed</v-chip>
    </template>


    <template v-slot:item.actions="{ item }">
      <v-tooltip v-if="!confirmedTaxRates && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="setActiveTaxRate(item, index); updateStatus()"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>confirm</span>
      </v-tooltip>
          <v-tooltip v-if="!confirmedTaxRates && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="reject(); setActiveTaxRate(item, index)"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>reject</span>
      </v-tooltip>
      <v-btn
        v-show="confirmedTaxRates"
        small outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
        @click="setActiveTaxRate(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>edit</span>
      </v-btn>
         <!-- The view button  -->
       <v-btn
        small outlined
        :disabled="edit" 
        @click="view = true; setActiveTaxRate(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>view</span>
      </v-btn>

      <!-- the delete icon  -->
        <v-icon
            :disabled="item.MakerID == currentUser.SecurityUserID && item.CheckerID == 0 ? false : true"
            color="#2A353D" @click="setActiveTaxRate(item, index); deleteDialog = true"
          >
          mdi-trash-can-outline
          </v-icon>
    </template>

    <template v-slot:item.IsAbsolute="{ item }">
      <v-simple-checkbox disabled
        v-model="item.IsAbsolute"
      ></v-simple-checkbox>
    </template>

    <template v-slot:item.TaxID="{ item }">
      {{getTaxCode(item.TaxID)}}
    </template>

    <template v-slot:item.EffectiveDate="{ item }">
      {{ item.EffectiveDate | moment("DD MMMM YYYY") }}
    </template>

    <template v-slot:item.MakeDate="{ item }">
      {{ item.MakeDate | moment("DD MMMM YYYY") }}
    </template>

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  name: 'dealer_limits',

  data () {
    return {
      confirmedTaxRates: true,
      edit: false,
      create:false,
      message: '',
      search: '',
      menu: '',
      valid: true,
      permitted: null,
      permitted_dialog: true,
      // initialisation of the view variable 
      view: false,
      deleteDialog: false,
      rejectionDialog: false,
      RejectionStatus: 0,
      content: '',
      currentTaxRate: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        {
          text: 'Tax',
          align: 'start',
          sortable: false,
          value: 'TaxID'
        },
        { text: 'Effective Date', value: 'EffectiveDate', sortable: true },
        { text: 'Rate', value: 'Rate', sortable: true },
        { text: 'Absolute', value: 'IsAbsolute', sortable: true },
        { text: 'Status', value: 'status', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      tax_rate: {},
    }
  },

  computed: {
    ...mapGetters([
      "allTaxRates",
      "allTaxes",
      "allRejectionReasons",
      "allUsers",
      "allConfirmationSettings"
    ]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    showDeleteBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 399).map(r => r.AllowDelete)) == 1){
        return true
      }
    }
    return false;
    },

    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 399).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 399).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 399).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 399).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  methods: {
    ...mapActions([
      "createTaxRate",
      "updateTaxRate",
      "deleteTaxRate"
   ]),

    async createNew() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        this.tax_rate.MakerID = this.currentUser.SecurityUserID,
        this.tax_rate.CheckerID = this.CheckerID,
        this.tax_rate.LastUserID = this.currentUser.SecurityUserID,
        this.createTaxRate(this.tax_rate)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newTaxRate',
            data: response.data
          });
          this.message = response.data.message
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })        
      }
    },

    async update() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
            if(this.currentTaxRate.CheckerID==0){
             // this.currentTaxRate.MakerID = this.currentUser.SecurityUserID
        this.currentTaxRate.LastUserID = this.currentUser.SecurityUserID,
        this.currentTaxRate.RejectionID= this.RejectionStatus,
        this.currentTaxRate.CheckerID = 0,
        this.currentTaxRate.CheckDate = null,
       // this.currentTaxRate.MakeDate = new Date(),

        this.updateTaxRate(this.currentTaxRate)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updTaxRate',
            data: this.currentTaxRate
          });
          
          this.message = response.data.message
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })       
            } 
            else{
              this.currentTaxRate.MakerID = this.currentUser.SecurityUserID
        this.currentTaxRate.LastUserID = this.currentUser.SecurityUserID,
        this.currentTaxRate.RejectionID= this.RejectionStatus,
       this.currentTaxRate.CheckerID = 0,
        this.currentTaxRate.CheckDate = null,
        this.currentTaxRate.MakeDate = new Date(),

        this.updateTaxRate(this.currentTaxRate)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updTaxRate',
            data: this.currentTaxRate
          });
          
          this.message = response.data.message
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })       
            }
      }
    },
// the delte function 
    deleteItem() {
      this.message = '';
      this.deleteTaxRate(this.currentTaxRate)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'dltTaxRate',
          data: this.currentTaxRate
        });
        
        this.message = response.data.message
        this.deleteDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.deleteDialog=false
      })        
   },

    updateStatus() {
      this.message = '';

      this.currentTaxRate.CheckerID = this.currentUser.SecurityUserID,
      this.currentTaxRate.LastUserID = this.currentUser.SecurityUserID,
      this.currentTaxRate.RejectionID = this.RejectionStatus,
      this.currentTaxRate.CheckDate = new Date(),
      this.currentTaxRate.updatedAt = new Date(),

      this.updateTaxRate(this.currentTaxRate)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updTaxRate',
          data: this.currentTaxRate
        });
        
        this.message = response.data.message
        this.rejectionDialog = false;
        this.RejectionStatus = 0
     },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.rejectionDialog = false;
        this.RejectionStatus = 0
      })
    },

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("Tax Rates", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Tax Rates.pdf')
      }
    },

    getTaxCode(id) {
      return this.allTaxes.filter(a => a.TaxID === id).map(a => a.TaxCode).toLocaleString()
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedTaxRates = false
    },

    showEdit () {
      this.edit = true
    },

    closeEdit() {
      this.edit = false
    },

    showCreate () {
      this.create = true
    },

    closeCreate() {
      this.tax_rate = {};
      this.create = false
    },

    reject () {
      this.rejectionDialog = true
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
    },

    reset () {
      this.$refs.form.reset()
    },

    setActiveTaxRate (item, index) {
      this.currentTaxRate = item
      this.currentIndex = index
    },
  },

  mounted () {
    UserService.isRates().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("unconfirmedTaxRates", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white
}
</style>
